import { SEGMENTS, VERTICALS } from '../constants/uriConstants';
import { QP_PAGE } from '../constants/queryParamConstants';
import serverVars from 'server-vars';
import get from 'lodash.get';

export function getSellerPath(sellerLabel) {
    return `/${SEGMENTS.SELLER}/${sellerLabel}/`;
}

/**
 * Helper function to deal with the fact that sometimes mobile web pages have the leading segment "/mobile"
 * @param url
 * @returns {[string,*]}
 */
export const stripRoutingSegment = uri => {
    return uri.replace(/^\/(mobile|resp|amp)/, '');
};

export function getHashFragment(uriRef) {
    if (uriRef) {
        return get(uriRef.match(/#.*/), '[0]') || '';
    }

    return '';
}

export function hasHashFragment(uriRef) {
    return !!getHashFragment(uriRef);
}

function addUrlSearchParamsToPath(urlSearchParams, uriRef) {
    const hashFragment = getHashFragment(uriRef);
    const [path] = uriRef.replace(hashFragment, '').split('?');

    urlSearchParams.sort();

    let newParamsString = urlSearchParams.toString();
    if (newParamsString) {
        newParamsString = `?${newParamsString}`;
    }

    return `${path}${newParamsString}${hashFragment}`;
}

function addUrlHashFragmentSearchParamsToPath(urlSearchParams, uriRef) {
    const hashFragment = getHashFragment(uriRef);
    const path = uriRef.replace(hashFragment, '');
    const [hashFragmentPath] = hashFragment.split('?');

    urlSearchParams.sort();

    let newParamsString = urlSearchParams.toString();
    if (newParamsString) {
        newParamsString = `?${newParamsString}`;
    }

    return `${path}${hashFragmentPath}${newParamsString}`;
}

const createUrlSearchParams = (uriRef = '') => {
    const hashFragment = getHashFragment(uriRef);
    return new URLSearchParams(get(uriRef.replace(hashFragment, '').split('?'), '[1]'));
};

const createUrlHashFragmentSearchParams = (uriRef = '') => {
    const hashFragment = getHashFragment(uriRef);
    return new URLSearchParams(get(hashFragment.split('?'), '[1]'));
};

export const createNewFilterUriRef = (uriRef, filterName, filterValue) => {
    const existingUrlSearchParams = createUrlSearchParams(uriRef);
    // ?page= should be always removed when filtering
    existingUrlSearchParams.delete(QP_PAGE);

    existingUrlSearchParams.set(filterName, filterValue);
    return addUrlSearchParamsToPath(existingUrlSearchParams, uriRef);
};

export const createNewUriRef = (uriRef = '', additionalQueryParams) => {
    const existingUrlSearchParams = createUrlSearchParams(uriRef);

    for (const qpKey in additionalQueryParams) {
        if (additionalQueryParams.hasOwnProperty(qpKey)) {
            existingUrlSearchParams.set(qpKey, additionalQueryParams[qpKey]);
        }
    }

    return addUrlSearchParamsToPath(existingUrlSearchParams, uriRef);
};

export const getNewPaginationUriRef = (uriRef, newPage) => {
    let currentUrlSearchParams;
    let addUrlParamsToPath;
    const hashFragment = getHashFragment(uriRef);

    if (hashFragment) {
        currentUrlSearchParams = createUrlHashFragmentSearchParams(uriRef);
        addUrlParamsToPath = addUrlHashFragmentSearchParamsToPath;
    } else {
        currentUrlSearchParams = createUrlSearchParams(uriRef);
        addUrlParamsToPath = addUrlSearchParamsToPath;
    }

    if (newPage === 1) {
        currentUrlSearchParams.delete('page');
    } else {
        currentUrlSearchParams.set('page', newPage);
    }

    return addUrlParamsToPath(currentUrlSearchParams, uriRef);
};

export const getQueryParam = (uriRef, paramName, fromHashFragment) => {
    if (fromHashFragment) {
        return createUrlHashFragmentSearchParams(uriRef).get(paramName);
    }

    return createUrlSearchParams(uriRef).get(paramName);
};

export function addCdnQueryParams(uriRef) {
    const cdnQueryParams = serverVars.get('cdnQueryParams') || {};
    /**
     * Can be null, can't use defaults. TODO: No reason for it to be null, FIX IT! Can prepopulate
     * it when creating the store.
     */
    if (!uriRef) {
        return '';
    }

    return createNewUriRef(uriRef, cdnQueryParams);
}

export const uriIncludesVertical = (uri = '') => {
    const verticals = Object.values(VERTICALS);
    return !!uri.split('/').find(segment => verticals.includes(segment));
};

export const isDealersShopUri = (uri = '') => {
    const [href] = uri.split('?');
    return !!href.match(/\/dealers\/(.*)\/shop/);
};

export function addTrailingSlash(url) {
    return typeof url === 'string' ? url.replace(/\/?(\?|#|$)/, '/$1') : '/';
}
